"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.toRichText = void 0;
var utils_1 = require("@lglp/utils");
var prismic_richtext_1 = require("prismic-richtext");
var link_1 = require("./link");
var toRichText = function (val, logger) {
    if (!val) {
        return undefined;
    }
    var richtext;
    // Regexp to find custom tags in richtexts using format (text)[type:param1|param2|...|paramN]
    var customTagRegExp = RegExp('\\(([^\\(]*)\\)\\[([^\\[]*):([^\\[]*)\\]', 'g');
    // Transfrom simple string to rich text prismic format
    if (typeof val === 'string') {
        richtext = [
            {
                type: 'paragraph',
                text: val.trim().replace(/\r?\n|\r/g, ''),
                spans: []
            },
        ];
    }
    else {
        richtext = val;
    }
    return richtext
        .filter(function (block) { return !utils_1.isVoid(block.text); })
        .map(function (block) {
        var match;
        var customSpans = [];
        while ((match = customTagRegExp.exec(block.text))) {
            customSpans.push({
                type: match[2],
                start: +match['index'],
                end: +match['index'] + match[0].length,
                data: match[3].split('|'),
                text: match[1]
            });
        }
        return __assign(__assign({}, block), { spans: __spreadArray(__spreadArray([], block.spans.map(function (span) {
                if (span.type === prismic_richtext_1.Elements.hyperlink) {
                    return __assign(__assign({}, span), { data: link_1.toLink(span.data, logger) });
                }
                return span;
            })), customSpans) });
    });
};
exports.toRichText = toRichText;
//# sourceMappingURL=rich-text.js.map